// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ai-0";
export var optionCard = "_ai-1";